import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Container, Alert } from 'react-bootstrap';

/**
 * Component to guard routes based on permissions
 * @param {string} module - The module name (e.g., 'inventory', 'transportation')
 * @param {string} permission - Optional specific permission required (e.g., 'approve', 'submit')
 * @param {ReactNode} children - The component to render if permission granted
 */
function PermissionGuard({ module, permission = null, children }) {
  const { hasPermission, permissions, loading } = useAuth();

  // Wait for permissions to load
  if (loading || !permissions) {
    return null;
  }

  // Check if user has the required permission
  const hasAccess = hasPermission(module, permission);

  if (!hasAccess) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">
          <Alert.Heading>Access Denied</Alert.Heading>
          <p>
            You do not have permission to access this page. 
            Please contact your administrator if you believe this is an error.
          </p>
        </Alert>
      </Container>
    );
  }

  return children;
}

export default PermissionGuard;

